import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";
import { useMilestoneHistory } from "../../../reactQuery/epics";
import { useResponsive } from "../../../hooks/useResponsive";
import { SanitizedHtml } from "../../../utils";
import CustomDateFormatter from "../../../utils/dateTimeFormatter";
import HistoryAvatar from "./components/HistoryAvatar";
import StatusChange from "./components/StatusChange";
import AssigneeChange from "./components/AssigneeChange";
import CreateMilestone from "./components/CreateMilestone";

const renderEventContent = (responseObject) => {
  const { event_type } = responseObject;

  switch (event_type) {
    case "milestone created test":
      return (
        <AssigneeChange
          oldAssignee={responseObject.old_assignee}
          newAssignee={responseObject.new_assignee}
        />
      );

    case "allocated_hours_update":
      return (
        <StatusChange
          oldValue={responseObject.old_allocated_hours}
          newValue={responseObject.updated_allcated_hours}
        />
      );

    case "change_board":
      return (
        <StatusChange
          oldValue={responseObject.old_board}
          newValue={responseObject.new_board}
        />
      );

    case "milestone created":
      return (
        <CreateMilestone data={responseObject} />
      );

    default:
      return (
        <div className="d-flex align-items-center history-heading">
          <p style={{ marginLeft: "5px" }}>{responseObject?.comment}</p>
        </div>
      );
  }
};

function MilestoneHistory({ showIcon = true }) {
  const [milestone] = useCustomSearchParams("milestone");
  const { history } = useMilestoneHistory(milestone);
  const isMobile = useResponsive("down", "md");
  const isBetween300And699 = useResponsive("between", 300, 699);

  return (
    <div>
      <Typography fontSize="16px" fontWeight={700} mt={2}>
        Activity
      </Typography>
      {history?.data?.data?.responseData.map((historyItem) => (
        <Box
          key={`milestone-history-${historyItem.at_time}`}
          sx={{ flexGrow: 1, px: isMobile ? "" : 2, width: "100%" }}
        >
          <Grid container spacing={2}>
            <div
              className={isMobile ? "mobile-worklog-box" : "worklog-box"}
              style={{ width: "100%" }}
            >
              <Grid>
                <HistoryAvatar
                  showIcon={showIcon}
                  userData={historyItem?.response_object?.user_object}
                />
              </Grid>
              <div
                className={
                  isMobile ? "mobile-worklog-box-body" : "worklog-box-body"
                }
              >
                <div className={isMobile ? "" : "d-flex"}>
                  <Grid sx={{ width: "100%" }}>
                    <div
                      className={
                        isBetween300And699
                          ? ""
                          : "d-flex justify-content-space-between"
                      }
                    >
                      <SanitizedHtml
                        as="div"
                        html={historyItem?.history_text}
                        className={isBetween300And699 ? "mobile-font" : ""}
                      />
                      <Typography className="worklog-box-date">
                        <div className="worklog-box-date-field">
                          <CustomDateFormatter date={historyItem.at_time} />
                        </div>
                      </Typography>
                    </div>

                    {historyItem.response_object && (
                      renderEventContent(historyItem.response_object)
                    )}
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Box>
      ))}
    </div>
  );
}

export default MilestoneHistory;
